import { CalendarIcon, Check, Clock } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { formatDuration } from "@/utils/formatDuration";
import { getFilterDisplayText } from "@/utils/dateFilters";
import { cn } from "@/lib/utils";

interface TimeEntryFilterProps {
  selectedMonth: string;
  setSelectedMonth: (month: string) => void;
  availableMonths: Array<{ value: string; label: string }>;
  totalDuration: number;
}

export function TimeEntryFilter({
  selectedMonth,
  setSelectedMonth,
  availableMonths,
  totalDuration,
}: TimeEntryFilterProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6 p-3 bg-gray-50 rounded-lg border border-gray-100 shadow-sm">
      <div className="font-medium text-gray-700 flex items-center">
        <Clock className="h-5 w-5 text-primary mr-2" />
        <span>Zeitübersicht</span>
      </div>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
        {/* Always reserve layout space; hide when only one month available */}
        <div className={cn("flex space-x-2 items-center", availableMonths.length <= 1 && "invisible")}>
          <Select value={selectedMonth} onValueChange={setSelectedMonth}>
            <SelectTrigger className={cn("w-[160px] bg-white", selectedMonth !== "current" && "border-primary text-primary")}>
              <SelectValue placeholder="Monat auswählen">
                <div className="flex items-center">
                  <CalendarIcon className="mr-2 h-4 w-4 text-gray-500" />
                  <span>{getFilterDisplayText(selectedMonth)}</span>
                </div>
              </SelectValue>
            </SelectTrigger>
            <SelectContent>
              {availableMonths.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  <div className="flex items-center justify-between w-full">
                    <span>{option.label}</span>
                    {selectedMonth === option.value && (
                      <Check className="h-4 w-4 ml-2" />
                    )}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <span className="text-gray-600 text-sm whitespace-nowrap bg-white px-3 py-2 rounded-md border border-gray-200 flex items-center">
          <Clock className="h-4 w-4 mr-2 text-primary" />
          Gesamt: {formatDuration(totalDuration)}
        </span>
      </div>
    </div>
  );
}
